// extracted by mini-css-extract-plugin
module.exports = {"icons":"UserComponent_icons__22hqF","readOnly":"UserComponent_readOnly__nI23T","selected":"UserComponent_selected__Bmzm_"};